module.exports = __webpack_public_path__ + "static/media/product-placeholder.3766a632.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product-placeholder.svg
// module id = 336
// module chunks = 0